import { render, staticRenderFns } from "./index.vue?vue&type=template&id=989e5444&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=989e5444&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/iy_web_test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('989e5444')) {
      api.createRecord('989e5444', component.options)
    } else {
      api.reload('989e5444', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=989e5444&", function () {
      api.rerender('989e5444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notification/index.vue"
export default component.exports